"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment/moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'fdpReport',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        retailerId: '',
        retailerName: '',
        orderNo: '',
        createDateStart: '',
        createDateEnd: '',
        receivedTimeStart: '',
        receivedTimeEnd: ''
      },
      form: {},
      region: [],
      regionOptions: []
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var createDateEnd = _this.searchVal.createDateEnd;
          if (createDateEnd) {
            var maxDate = (0, _moment.default)(createDateEnd, 'YYYY-MM-DD').toDate();
            var minDate = (0, _moment.default)(createDateEnd, 'YYYY-MM-DD').subtract(12, 'month');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var createDateStart = _this.searchVal.createDateStart;
          if (createDateStart) {
            var minDate = (0, _moment.default)(createDateStart, 'YYYY-MM-DD').toDate();
            var maxDate = (0, _moment.default)(createDateStart, 'YYYY-MM-DD').add(12, 'month'); // 向后30天
            if (timeGetTime < minDate || timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    receivedStartPickerOptions: function receivedStartPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var receivedTimeEnd = _this.searchVal.receivedTimeEnd;
          if (receivedTimeEnd) {
            var maxDate = (0, _moment.default)(receivedTimeEnd, 'YYYY-MM-DD').toDate();
            var minDate = (0, _moment.default)(receivedTimeEnd, 'YYYY-MM-DD').subtract(12, 'month');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    receivedEndPickerOptions: function receivedEndPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var receivedTimeStart = _this.searchVal.receivedTimeStart;
          if (receivedTimeStart) {
            var minDate = (0, _moment.default)(receivedTimeStart, 'YYYY-MM-DD').toDate();
            var maxDate = (0, _moment.default)(receivedTimeStart, 'YYYY-MM-DD').add(12, 'month'); // 向后30天
            if (timeGetTime < minDate || timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      _this2.searchData();
    }, 300);
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      console.log(param);
      this.listLoading = true;
      this.$api.reportModule.getFDPList(param, this.sourceApi.token).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.data.items;
        _this3.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this3.listLoading = false;
      });
    },
    resetData: function resetData() {
      var _this4 = this;
      setTimeout(function () {
        _this4.searchVal.retailerId = '';
        _this4.searchVal.retailerName = '';
        _this4.searchVal.orderNo = '';
        _this4.searchVal.createDateStart = '';
        _this4.searchVal.createDateEnd = '';
        _this4.searchVal.receivedTimeStart = '';
        _this4.searchVal.receivedTimeEnd = '';
        _this4.searchData();
      }, 300);
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    downloadExcel: function downloadExcel() {
      var _this5 = this;
      // if (!this.searchVal.startTime || !this.searchVal.endTime) {
      //   this.$message.warning(this.$t('sfe.fdpreport.input.dataHolder'))
      //   return
      // }
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.fdpreport.exportFileName');
      this.$api.reportModule.exportFDPList(this.searchVal).then(function (res) {
        _this5.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this5.$message.error(_this5.$t('sfe.fdpreport.input.exportFailed'));
        console.log(err);
        _this5.isLoading = false;
      });
    }
  }
};